import React from 'react'
import { useState ,useEffect} from 'react'
import TweetBox from './TweetBox'
import "./Timeline.css"
import Post from './Post'
import db, {auth} from "./firebase"
import { collection, getDocs ,onSnapshot,orderBy,query, QuerySnapshot} from 'firebase/firestore'
import HomeIcon from '@mui/icons-material/Home';
import { post } from '../types'




const Timeline=()=> {

  const [posts,setPosts] = useState<any[]>([]);
  
  
    
  

  useEffect(() => {
    const postData=collection(db,"posts")
    const q =query(postData ,orderBy("timestamp","desc")) 
    onSnapshot(q,(querySnapshot)=>{
      setPosts(querySnapshot.docs.map((doc)=>({...doc.data(),id:doc.id})))
    })
  }, [])
  
  return (
    <div className='timeline'>
     <div className='timeline--header'>
      <HomeIcon/>
     </div>
      <TweetBox/>
     
     {posts.map((post:post)=>(
      <Post 
      id={post.id}
      aid={post.aid}
      displayName={post.displayName}
      verified={post.verified}
      text={post.text}
      avatar={post.avatar}
      price={post.price}
      image={post.pic}
     />
     ))}
     
    </div>
  )
}

export default Timeline